<template>
  <div id="wrapper">
    <div id="manage-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
    <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_people_on.png" alt="">
            {{$t('organizationListStr')}}
          </h1>
          <span class="info-right">
          </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <!-- 1on1item -->
          <manage-wrapper-component require-admin>
            <div class="ibox">
              <div class="ibox-content">
                <div class="ibox-title search-box">
                  <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithOrganizationName')">
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="ibox-content search-resultview">
                  <ul v-if="searchText == ''">
                    <li id="group1" class="flex-box fl-between align-items-center group-item cursor">
                      <h4 class="title-label" for="status">{{$t('organizationListStr')}}</h4>
                      <span class="left-buttons">
                      <b-btn v-b-modal.modalRegOrganizations variant="gray-600">{{$t('organizationListRegistStr')}}</b-btn>
                      <b-btn class="btn" @click="downloadOrganization" variant="gray-600">{{$t('csvDownloadStr')}}</b-btn>
                      </span>
                      <span class="info-right">
                        <router-link class="btn btn-success add-public" to="OrganizationEdit">
                          <i class="fa fa-plus"></i>{{$t('organizationRegTitle')}}
                        </router-link>
                      </span>
                    </li>
                    <organization-item  :OrganizationPath="getRootpath" @onClickOrganization="onClickGroup"/>
                  </ul>
                  <ul v-else>
                    <li><label>{{$t('searchResuleStrType')}}</label></li>
                    <template v-if="Object.keys(this.getOrganizationsBySearchText).length === 0">
                      <li><label>{{$t('notFoundOrganizationNameStr')}}</label></li>
                    </template>
                    <template v-else>
                      <organization-item :OrganizaitonPath="getOpens" @onClickOrganization="onClickGroup"/>
                    </template>
                  </ul>
                </div>
                <!-- /公開設定 -->
              </div>
            </div>
          </manage-wrapper-component>
          <!-- /1on1item -->
        </section>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">
                  {{ this.targetGroup.groupName }}
                </span>
                <span class="info-right">
                  <span class="group-info">{{$t('memberStr')}}: ({{Object.keys(this.targetGroup.members || {}).length}})</span>
                </span>
              </div>
              <template>
                <div class="ibox-child">
                  <div class="search-resultview">
                    <ul>
                      <li v-for="user in getUsersInfo" :key="user.id"><label>
                        <span v-if="getGroupOwner(user.userId)" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                        <router-link :to="{ name: 'User', params: { userId: user.userId }}">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                        </router-link>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                      </label></li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
          </section>
        </article>
      </div>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalRegOrganizations" v-if="isManager"
      ref="modal"
      :title="$t('organizationListRegistStr')"
      scrollable
      centered
      no-close-on-backdrop
      :hide-header=regHandle
      :hide-footer=regHandle
      @ok="handleOk"
      @cancel="handleClear"
      @shown="clearOrganizations"
    >
      <div v-if="!regHandle">
        <b-alert variant="danger" v-for="(errOrg, index) in errOrganizations" :key="index"
          dismissible
          fade
          :show="!errOrg.dismissed"
          @dismissed="errOrg.dismissed = true">
          {{ errOrg.error + ' : ' + errOrg.line }}
        </b-alert>
        <form @submit.stop.prevent="handleSubmit">
          <b-form-textarea
            :placeholder="$t('phtextRegOrganizations')"
            rows="10"
            max-rows="10"
            v-model="txtOrganizations"
          />
        </form>
        <b-row class="mt-4">
          <b-col cols="4">
            <button class="btn btn-success block" @click="loadFile">
              {{$t('readFromFileStr')}}
            </button>
          </b-col>
          <b-col>
            <span class="text-danger small">{{$t('organizationRegistAttentionStr')}}</span>
            <br>
            <span class="text-danger small">{{$t('organizationRegistAttentionStr2')}}</span>
          </b-col>
        </b-row>
        <form id ='clearfile'><input type="file" accept=".txt, .csv" @change="changeFile" ref="fileInput" class="d-none"></form>
      </div>
      <div v-else>
        <b-alert variant="info" show>{{ $t('registerInProgress') }}</b-alert>
        <p>{{ $t('registerOrganizationsMessage') }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ManageGroupDropDown from '@/components/Manage/ManageGroupDropDown'
import OrganizationItem from '@/components/People/OrganizationItem'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
import { mapGetters } from 'vuex'
import encoding from 'encoding-japanese'

// 組織登録時バリデーション用
const byte = (str) => {
  var length = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      length += 1
    } else {
      length += 2
    }
  }
  return length
}
const groupNameLengthValidation = (groupName) => {
  if (Number(byte(groupName)) > 40) { // TODO: MagicNumber to Const
    return false
  } else {
    return true
  }
}
const groupNameProhibitedCharacter = (groupName) => {
  return !groupName.match(/\/|,/g)
}

export default {
  name: 'ManageOrganization',
  components: {
    ManageGroupDropDown,
    OrganizationItem,
    ManageWrapperComponent
  },
  data: function () {
    return {
      tag: 'ManageOrganization',
      searchText: '',
      open: false,
      result: false,
      targetGroup: {
        members: {},
        groupName: '',
        ownerId: ''
      },
      targetGroupId: '',
      visibleOrganizations: [],
      txtOrganizations: '',
      regOrganizations: [],
      errOrganizations: [],
      regHandle: false
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ManageOrganization'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('peoples/', [
      'downloadCSV'
    ]),
    ...mapGetters('organizations/', [
      'getOrganizationCSV',
      'getOnlyOrganizationsByText',
      'getOpenOrganization',
      'getOnlyOrganizationsByIds'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    ...mapGetters('groups/', [
      'getOnlyGroupsByText',
      'getOnlyGroupsByIds',
      'getGroups'
    ]),
    ...mapGetters('_meta/', [
      'getMetaUsersList',
      'getMetaIsDeveloper',
      'getMetaIsManager'
    ]),
    getOpens: function () {
      let searchOpens = {}
      searchOpens = {roots: [], node: []}
      let getOpenAllOrganizations = this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText))
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText)))
      for (let ser of Object.values(this.getOpenOrganization(Object.keys(this.getOrganizationsBySearchText)))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      // {a:[],b:[],c:[]}
      console.log('searchopens:', searchOpens, getOpenAllOrganizations)
      return searchOpens
    },
    getRootpath: function () {
      return {default: true}
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    },
    getCSV: function () {
      return this.getOrganizationCSV
    },
    getUsersInfo: function () {
      return this.getUsersByIds(Object.keys(this.targetGroup.members || {}))
    },
    isManager: function () {
      return this.getMetaIsManager
    },
    getOnlyOrganizationsInfo: function () {
      let organizations = this.getOnlyOrganizationsByIds(Object.keys(this.getGroups))
      // return this.getGroupsByIds(Object.keys(this.getGroups))
      return organizations
    },
    setOrganizations: function () {
      return this.getOnlyOrganizationsInfo['root']
    }
  },
  mounted: function () {
    if (this.$route.params.item) {
      this.targetGroup = this.getOnlyOrganizationsInfo[this.$route.params.item.group]
      this.targetGroupId = this.$route.params.item.group
      if (this.targetGroup) {
        this.open = true
      } else {
        const $t = this.$t
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('deletedOrganizationStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    }
  },
  methods: {
    onClickGroup: function (groupId) {
      this.targetGroup = this.getGroups[groupId]
      this.targetGroupId = groupId
      if (!this.open) {
        this.open = true
      }
    },
    getGroupOwner: function (user) {
      return this.getGroups[this.targetGroupId].ownerId === user
    },
    downloadOrganization: function () {
      const organizationCSV = this.getCSV
      this.downloadCSV(organizationCSV, 'organization')
    },
    regOrganizationList () {
      console.log('regOrganizationList: ', this.regOrganizations)
      // let regOrgList = []
      const setOrganizationsFromList = this.$firebase.functions().httpsCallable('setOrganizationsFromList')
      const sendData = { organizations: this.regOrganizations }
      return setOrganizationsFromList(sendData)
        .then(res => {
          console.log('setOrganizationsFromList:res', res, this.regOrganizations)
        })
        .catch(err => {
          console.log('setOrganizationsFromList:err', err)
        })
        .finally(() => {
          this.handleClear()
        })
    },
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      let orgs = this.txtOrganizations.trim().split('\r').join('').split('\n')
      if (orgs.length) {
        this.regOrganizations = orgs
      }
      console.log('handleOk: ', this.regOrganizations)
      if (this.regOrganizations.length && this.regOrganizations.join('')) {
        this.handleSubmit()
      } else {
        this.handleClear()
      }
    },
    handleSubmit () {
      const orgList = this.regOrganizations || []
      const orgItems = orgList.map(x => ('' + x).replace(/,,*$/, '').split(','))
      console.log('handleSubmit:', this.regOrganizations, orgItems)
      console.log('handleSubmit: clear errOrganizations.')
      this.errOrganizations = []
      const orgTree = {}
      const ORG_MAX_LEVEL = 8 // TODO: どこか外で定義した方が良さげ…
      for (let i in orgItems) {
        const item = orgItems[i]
        switch (true) {
          case (item.some(x => !groupNameLengthValidation(x.trim()))): // 文字数チェック
            this.errOrganizations.push({
              error: this.$t('warningOrganizationNameStr'),
              line: orgList[i],
              dismissed: false
            })
            break
          case (item.some(x => !groupNameProhibitedCharacter(x.trim()))): // 使用不可能文字チェック
            this.errOrganizations.push({
              error: this.$t('warningOrganizationProhibitedCharacterStr'),
              line: orgList[i],
              dismissed: false
            })
            break
          case (item.some(x => !x.trim())): // 空の項目がある
            this.errOrganizations.push({
              error: this.$t('errRegOrganizationsEmptyColumn'),
              line: orgList[i],
              dismissed: false
            })
            break
          case (orgTree.hasOwnProperty(item.join('/'))): // 重複
            this.errOrganizations.push({
              error: this.$t('errRegOrganizationsDuplicateItem'),
              line: orgList[i],
              dismissed: false
            })
            break
          case (item.length === 1): // 重複しない単独項目は最上位組織
            orgTree[item.join('/')] = true
            break
          case (!orgTree.hasOwnProperty(item.slice(0, -1).join('/'))): // 上位階層
            this.errOrganizations.push({
              error: this.$t('errRegOrganizationsParentNotFound'),
              line: orgList[i],
              dismissed: false
            })
            break
          case (item.length > ORG_MAX_LEVEL): // 階層上限
            this.errOrganizations.push({
              error: this.$t('errRegOrganizationsOverMaxLevels'),
              line: orgList[i],
              dismissed: false
            })
            break
          default:
            orgTree[item.join('/')] = true
            break
        }
      }

      console.log(this.errOrganizations, this.regOrganizations)

      if (this.errOrganizations.length === 0) {
        // this.handleClear()
        this.regHandle = true
        return this.regOrganizationList()
      }

      return false
    },
    handleClear () {
      console.log('onclick handleClear')
      this.regHandle = false
      this.clearOrganizations()
      this.$refs.modal.hide()
    },
    clearOrganizations () {
      var area = document.getElementById('clearfile')
      console.log({area})
      if (area) {
        area.reset()
        var temp = area.innerHTML
        console.log(temp)
        area.innerHTML = temp
      }
      this.regOrganizations = []
      this.errOrganizations = []
      this.txtOrganizations = ''
    },
    changeFile (event) {
      console.log(this.$refs.fileInput.files)
      if (this.$refs.fileInput.files[0]) {
        console.log('change file::::')
        let reader = new window.FileReader()
        reader.readAsBinaryString(this.$refs.fileInput.files[0])
        reader.onloadend = event => {
          let result = event.target.result
          let text = encoding.convert(result, 'UNICODE', 'AUTO')
          // console.log('* encoding-japanese', {result, text})
          // text = text.replace(/ +/g, '') // 組織名に空白がありうるので削除はやめる。TODO: erase
          this.txtOrganizations = text.trim().split('\r').join('').split('\n').filter(x => x.length !== 0).join('\n')
          console.log(reader.readyState)
        }
      } else {
        console.log(this.$refs.fileInput)
      }
    },
    loadFile () {
      console.log('loadFile')
      this.$refs.fileInput.click()
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.ibox-child
span.crown-mark {
    top: 0.9rem;
    left: -1.8rem;
}
.left-buttons {
  flex: auto;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageOrganization.vue